/**
 * RememberIcon — Remember callout icon. Powder-blue background, navy
 * thumbtack glyph (pin shaft + base bracket + pin point). The lightest of
 * the four callouts; "gentle reminder" semantics — cool-on-cool, the
 * inverse of Tip/WatchOut's filled-on-saturated combination is intentional.
 *
 * Production SVG landed 2026-05-04 in
 * /design/icons/callout-remember-thumbtack.svg. The previous stub used a
 * single compressed-path glyph; production splits into 3 primitives
 * (shaft / base bracket / point) for clearer geometry + accessibility.
 */

import IconCircle from "./IconCircle.jsx";

export default function RememberIcon({ size = 38 }) {
  const stroke = "var(--ppr-color-accent-navy)";
  return (
    <IconCircle size={size} bg="var(--ppr-color-accent-powder)">
      <svg
        width={size * 0.55}
        height={size * 0.55}
        viewBox="0 0 24 24"
        fill="none"
        role="img"
        aria-label="Remember"
      >
        {/* Pin shaft (top stem above the bracket) */}
        <line
          x1="12"
          y1="3"
          x2="12"
          y2="13"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />
        {/* Pin base bracket (the body of the thumbtack) */}
        <path
          d="M 8 15 L 16 15 L 14 13 L 14 4 L 10 4 L 10 13 L 8 15 Z"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinejoin="round"
        />
        {/* Pin point (sharp tip below the bracket) */}
        <line
          x1="12"
          y1="15"
          x2="12"
          y2="21"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />
      </svg>
    </IconCircle>
  );
}
